import { css } from "simplydo/react/styled";
import { Card, CardContent, CardHeader } from "simplydo/react/ui/card";
import { H2, Subheader } from "simplydo/react/ui/header";

type IEmptyBox = {
  title?: string;
  message?: string;
  children?: any;
  style?: any;
};

function EmptyBox({ title, message, children, style }: IEmptyBox) {
  return (
    <Card style={style} fluid placeholder elevation="small">
      {title ? (
        <CardHeader>
          <H2>{title}</H2>
          {message ? <Subheader>{message}</Subheader> : null}
        </CardHeader>
      ) : null}
      <CardContent style={{ textAlign: "center" }}>{children}</CardContent>
    </Card>
  );
}

export default EmptyBox;
